import React from 'react';
import Logo from '../assets/facebook-contacto.png';

function LogoFacebookContacto() {
  return <img src={Logo} alt="Logo" className="m-2" />;
}

export default LogoFacebookContacto;
